import logo from "../assets/lumacofono-logo.jpeg";
import { EXPERIENCES, SOCIALS } from "../lib/config";
import { Link } from "react-router-dom";

const Brand = {
  youtube: <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />,
  instagram: <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.8.3 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.1.4.3 1 .4 2.2.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.1-1 .3-2.2.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.8-.3-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.1-.4-.3-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.1 1-.3 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 1.8c-3.1 0-3.5 0-4.7.1-1.1.1-1.7.2-2.1.4-.5.2-.9.4-1.3.8-.4.4-.6.8-.8 1.3-.2.4-.3 1-.4 2.1C2.6 10 2.6 10.4 2.6 12s0 2 .1 3.2c.1 1.1.2 1.7.4 2.1.2.5.4.9.8 1.3.4.4.8.6 1.3.8.4.2 1 .3 2.1.4 1.2.1 1.6.1 4.7.1s3.5 0 4.7-.1c1.1-.1 1.7-.2 2.1-.4.5-.2.9-.4 1.3-.8.4-.4.6-.8.8-1.3.2-.4.3-1 .4-2.1.1-1.2.1-1.6.1-3.2s0-2-.1-3.2c-.1-1.1-.2-1.7-.4-2.1-.2-.5-.4-.9-.8-1.3-.4-.4-.8-.6-1.3-.8-.4-.2-1-.3-2.1-.4-1.2-.1-1.6-.1-4.7-.1zm0 3.1a4.9 4.9 0 1 1 0 9.8 4.9 4.9 0 0 1 0-9.8zm0 8a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4zm6.2-8.2a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0z" />,
  spotify: <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.6 14.4a.62.62 0 0 1-.86.2c-2.35-1.43-5.3-1.76-8.79-.96a.62.62 0 1 1-.28-1.21c3.8-.87 7.08-.49 9.72 1.11.3.18.39.57.21.86zm1.23-2.73a.78.78 0 0 1-1.07.26c-2.69-1.65-6.79-2.13-9.97-1.17a.78.78 0 1 1-.45-1.49c3.63-1.1 8.15-.56 11.24 1.33.37.23.48.71.25 1.07zm.11-2.84C14.72 8.97 9.5 8.8 6.5 9.71a.93.93 0 1 1-.54-1.78c3.44-1.05 9.2-.85 12.84 1.31a.93.93 0 1 1-.95 1.6z" />,
  tiktok: <path d="M16.6 5.8a4.3 4.3 0 0 1-1-2.8h-3.2v12.2a2.3 2.3 0 1 1-2.3-2.3c.2 0 .5 0 .7.1V7.7a5.6 5.6 0 0 0-.7-.05 5.5 5.5 0 1 0 5.5 5.5V8.9a7.3 7.3 0 0 0 4.3 1.4V7.1a4.3 4.3 0 0 1-3.3-1.3z" />,
  twitch: <path d="M4.3 2 3 5.4v13.3h4.5V22h2.5l2.3-3.3h3.6L22 13V2H4.3zm15.4 10.3-2.6 2.6h-3.6l-2.3 2.3v-2.3H7.6V3.6h12.1v8.7zM16.3 6.6h-1.6v4.7h1.6V6.6zm-4.3 0h-1.6v4.7H12V6.6z" />,
};

export const Footer = () => {
  return (
    <footer className="mt-14 sm:mt-16" data-testid="site-footer"
      style={{ background: "var(--luma-night)", color: "#fff", borderRadius: "28px 28px 0 0" }}>
      <div className="w-[min(1160px,calc(100%-32px))] mx-auto py-9 sm:py-10">
        <div className="grid gap-8 sm:grid-cols-[1.2fr_1fr_1fr]">
          <div className="sm:col-span-1" style={{ gridColumn: "1 / -1" }}>
            <a href="https://www.lumacofono.com" target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-3" data-testid="footer-logo-link">
              <img src={logo} alt="Lumacofono" className="w-[56px] h-[56px] object-contain rounded-xl bg-white" />
              <span className="font-display" style={{ fontSize: 24 }}>Lumacofono</span>
            </a>
          </div>

          <div>
            <h3 className="font-bold mb-3" style={{ fontSize: 13, letterSpacing: ".08em", textTransform: "uppercase", color: "#B6C5D9" }}>
              Esperienze
            </h3>
            <div className="grid gap-1">
              {EXPERIENCES.map((e, i) =>
                e.external ? (
                  <a key={i} href={e.url} target="_blank" rel="noopener noreferrer"
                    data-testid={`footer-exp-${i}`} className="py-1.5 text-sm" style={{ color: "#E0E8F3" }}>
                    {e.label}
                  </a>
                ) : (
                  <Link key={i} to={e.to} data-testid={`footer-exp-${i}`} className="py-1.5 text-sm" style={{ color: "#E0E8F3" }}>
                    {e.label}{e.current ? " — sei qui" : ""}
                  </Link>
                )
              )}
            </div>
          </div>

          <div>
            <h3 className="font-bold mb-3" style={{ fontSize: 13, letterSpacing: ".08em", textTransform: "uppercase", color: "#B6C5D9" }}>
              Canali ufficiali
            </h3>
            <div className="grid gap-1">
              {SOCIALS.map((s) => (
                <a key={s.key} href={s.url} target="_blank" rel="noopener noreferrer"
                  data-testid={`footer-social-${s.key}`}
                  className="py-1.5 text-sm flex items-center gap-2.5" style={{ color: "#E0E8F3" }}>
                  <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor" aria-hidden="true">{Brand[s.key]}</svg>
                  {s.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-6 pt-4 flex flex-wrap gap-3 justify-between items-start"
          style={{ borderTop: "1px solid #FFFFFF25", color: "#B6C5D9", fontSize: 12 }}>
          <p className="m-0 max-w-2xl leading-relaxed">
            One Piece © Eiichiro Oda / Shueisha, Toei Animation. Fruttipedia è un progetto
            amatoriale di Lumacofono, non affiliato né approvato dai detentori dei diritti.
          </p>
          <p className="m-0">© {new Date().getFullYear()} Lumacofono</p>
        </div>
      </div>
    </footer>
  );
};
